import AppFunction from "../../../../../core/helpers/app/AppFunction.js";

export const table = {
    data() {
        return {
            tableColumns: [
                {
                    title: this.$t('Creation Date'),
                    type: 'custom-html',
                    key: 'created_at',
                    modifier: (value) => {
                        return value ? new Date(value).toISOString().split('T')[0] : '';
                    }
                },
                { 
                    title: this.$t('Number'), 
                    modifier : (_) => {
                        return `class=text-center`
                    },
                    key: 'cost_number',
                    type: 'custom-html',
                    isVisible: true,
                    ClassName: 'center',
                    modifier: (value) => {
                        return `<div">
                                <span style="font-weight: bolder;">${value}</span> 
                            </div>`;
                    }
                },

                { 
                    title: this.$t('Contract'), 
                    modifier : (_) => {
                        return `class=text-center`
                    },
                    key: 'contract',
                    type: 'custom-html',
                    isVisible: true,
                    ClassName: 'center',
                    modifier: (value) => {
                            return `<div">
                                        <span style="font-size: 14px; font-weight: bolder;">${value?.number ?? ''}</span> 
                                    </div>`;
                        
                    } 
                },

                { 
                    title: this.$t('Type'), 
                    type: 'custom-html', 
                    key: 'cost_type',
                    isVisible: true,
                    headerClass: 'center',
                    ClassName: 'center', 
                    modifier: (value, row) => {
                        let imageUrl = ''; 
                        if (typeof value === 'string') {
                            if (value.startsWith('o')) {
                                imageUrl = AppFunction.getAppUrl('images/barco.jpg');
                            } else if (value.startsWith('t')) { // Use else if for mutually exclusive conditions
                                imageUrl = AppFunction.getAppUrl('images/camion.jpg');
                            }
                        }
                        return `<div style="display: flex; justify-content: center; align-items: center; height: 50%;">
                            <img src="${imageUrl}" alt="Shipment Type" style="max-width: 60%; max-height: 60px;">
                        </div>`;
                    
                    },
                },
                { 
                    title: this.$t('Country'), 
                    modifier : (_) => {
                        return `class=text-center`
                    },
                    key: 'country',
                    type: 'custom-html',
                    isVisible: true,
                    ClassName: 'center',
                    modifier: (value) => {
                        return `<div">
                                <span style="font-size: 14px; ">${value.name}</span> 
                            </div>`;
                        
                    }  
                },
                { 
                    title: this.$t('Supplier'), 
                    modifier : (_) => {
                        return `class=text-center`
                    },
                    key: 'supplier',
                    type: 'custom-html',
                    isVisible: true,
                    ClassName: 'center',
                    modifier: (value) => {
                        return `<div">
                                <span style="font-size: 14px; ">${value.Second_Title}</span> 
                            </div>`;
                        
                    } 
                },
                { 
                    title: this.$t('Customer'), 
                    modifier : (_) => {
                        return `class=text-center`
                    },
                    key: 'customer',
                    type: 'custom-html',
                    isVisible: true,
                    ClassName: 'center',
                    modifier: (value) => {
                        return `<div">
                                <span style="font-size: 14px; ">${value.Second_Title}</span> 
                            </div>`;
                        
                    } 
                },
                { 
                    title: this.$t('Product'),
                    modifier : (_) => {
                        return `class=text-center`
                    },
                    key: 'product_concat',
                    type: 'custom-html',
                    isVisible: true,
                    ClassName: 'center',
                    modifier: (value) => {               
                        return `<div">
                                <span style="font-size: 14px; ">${value}</span> 
                            </div>`;
                        
                    }
                },
                { title: this.$t('Final Destination'), type: 'text', key: 'final_destination_value' },
                { title: this.$t('Comments'), type: 'text', key: 'comment' },
                // { title: this.$t('Total Cost'), type: 'text', key: 'totalcost_value' },
                { 
                    title: this.$t('Status'), 
                    type: 'custom-html',
                    key: 'cost_status',
                    isVisible: true,
                    modifier: (value) => {        
                        const STATUS_BADGE_CONFIG = {
                            'pending': {
                                colorClass: 'warning-badge', 
                                textKey: 'Pending'            
                            },
                            'completed': {
                                colorClass: 'success-badge',
                                textKey: 'Completed'
                            },
                            'contrated': {
                                colorClass: 'info-badge',  
                                textKey: 'Contrated' 
                            },
                            'default': {
                                colorClass: 'info-badge',  
                                textKey: 'undefined' 
                            }
                        };

                        if (value) {
                            const statusConfig = STATUS_BADGE_CONFIG[value] || STATUS_BADGE_CONFIG.default;
                            return `<span class="professional-badge professional-badge-${statusConfig.colorClass}">
                                    ${this.$t(statusConfig.textKey)}
                                </span>`;
                        }
                    return '';
                    } 
                },
                { title: this.$t('action'), type: 'action', key: 'action' },
            ]
        };
    }
}